/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import React from 'react';

interface IMetadataErrorMessageComponent {
    error: any;
}

export default (props: IMetadataErrorMessageComponent) => {
    const { error } = props;

    return (
        <div className="jr-mMessage jr-mMessageError jr jr-mMessagePlain ">
            <div className="jr-mMessage-iconContainer jr">
                <span className="jr-mMessage-icon jr" />
            </div>
            <div className="jr-mMessage-textContainer jr">
                <p className="jr-mMessage-title jr" />
                <p className="jr-mMessage-text jr">{error}</p>
            </div>
        </div>
    );
};
